/* eslint-disable no-console */

import { registerSW } from "virtual:pwa-register";

if (process.env.NODE_ENV === "production") {
  // autoUpdate: the new worker skips waiting and registerSW reloads the page once it
  // takes control, so every deploy still forces open tabs onto the new build.
  const hadController = !!navigator.serviceWorker?.controller;
  navigator.serviceWorker?.addEventListener("controllerchange", () => {
    if (hadController) console.log("New content is available; forcing reload.");
  });

  registerSW({
    immediate: true,
    onRegisteredSW(swUrl, registration) {
      console.log("Service worker has been registered.");
      // A worker that waits for the page to release it (the Vue CLI one, e.g. on a
      // rollback) is told to take over, as register-service-worker used to do.
      const skipWaiting = (worker) => {
        if (worker && navigator.serviceWorker.controller)
          worker.postMessage({ type: "SKIP_WAITING" });
      };
      skipWaiting(registration?.waiting);
      registration?.addEventListener("updatefound", () => {
        console.log("New content is downloading.");
        const worker = registration.installing;
        worker?.addEventListener("statechange", () => {
          if (worker.state === "installed") skipWaiting(worker);
        });
      });
      navigator.serviceWorker.ready.then(() =>
        console.log(
          "App is being served from cache by a service worker.\n" +
            "For more details, visit https://goo.gl/AFskqB"
        )
      );
    },
    onOfflineReady() {
      console.log("Content has been cached for offline use.");
    },
    onRegisterError(error) {
      if (!navigator.onLine) {
        console.log(
          "No internet connection found. App is running in offline mode."
        );
        return;
      }
      console.error("Error during service worker registration:", error);
    },
  });
}
